'use client'

import { useMountEffect } from '@react-hookz/web'

import isEmpty from 'lodash/fp/isEmpty'

export default function ScrollToAnchor() {
  useMountEffect(() => {
    const { hash } = window.location
    if (!isEmpty(hash) && hash.length > 1) {
      const id = hash.substring(1)

      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  })

  return false
}
